import Vue from 'vue';
import 'babel-polyfill';

import '@assets/styles/default.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@assets/styles/theme.less';
import '@assets/styles/iconfont.css';
import '@assets/styles/common.less';

import '@components/core/registerComponent';
import '@components/core/registerAjax';
import '@components/core/registerDirective';
import '@components/core/registerFilter';
import { lxBidTracker, lxCidTracker } from '@util/lxTracker';
import { checkGrayItem } from '@util/handleGrayByLocalstorage';

import moment from 'moment';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;

import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import {track} from '@util/track';
Vue.prototype.$track = track;

import isCRMUser from '@util/isCRMUser';
Vue.prototype.$isCRMUser = isCRMUser();

//在应用启动时，可以通过设置 Vue.config.productionTip = false 来关闭生产模式下给出的提示
Vue.config.productionTip = false;

Vue.prototype.$agency = {};

import App from './App.vue';
import router from './router';
import store from './store';

global.vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
});

import * as subAppUtils from "@util/subApp";
const menus = subAppUtils.SUBAPP_MENU;

Vue.prototype.navigateTo = function (params) {
  const {path} = params;
  //根据location.hash来寻找微服务模块名称
  const subApp = Object.keys(menus).filter((item) => {
    return path.indexOf(item) !== -1;
  })[0];
  if (menus[subApp] && menus[subApp].status !== 'loaded') {
    window.subAppUtils.loadSubApp(subApp);
  }
  this.$router.push(params);
};

window.subAppUtils = {
  ...subAppUtils,
  Vue,
  state: global.vm.$store.state,
  from: 'hq-static'
};

router.afterEach((to, from) => {
  // 统计代码
  if (from.name) {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath
      , window.location.origin]);
  } else {
    _hmt.push(['_trackPageview'
      , '/#' + to.fullPath]);
  }
  // cat 配置pageUrl
  let path = to.matched.length > 0 ? to.matched[to.matched.length - 1].path : '';
  window.Owl && window.Owl.config({
    pageUrl: `${window.location.host}${path}`
  });
  // lx 埋点路由信息
  lxCidTracker(to);
});

// vue捕获报错信息 && cat 错误日志上报
import {vueErrorHandel} from '@util/vueErrorHandel';
Vue.config.errorHandler = vueErrorHandel;
// 灵犀事件埋点
Vue.prototype.$lxBidTracker = lxBidTracker;
// 重复点击灰度
Vue.prototype.$isRepeatGray = checkGrayItem('new-repeat-click');



// WEBPACK FOOTER //
// ./src/index.js